var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body",class:_vm.bodyClass},[(_vm.title)?_c('div',{staticClass:"flex justify-between items-center",class:_vm.titleClass},[_vm._t("title")],2):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }